/*
  PBL (Oct 2026): copy campaign parameters onto the order.
  Reads UTMs and the Google click ID from the landing URL, keeps the latest set for
  30 days, and writes them to the cart as attributes. A new campaign replaces the
  whole set, and an expired set is cleared from the cart. Shopify carries cart attributes
  onto the order, where they show under "Additional details".
*/
(function () {
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid'];
  var STORE_KEY = 'pbl_utm';
  var SYNC_KEY = 'pbl_utm_synced';
  var WRITTEN_KEY = 'pbl_utm_written';
  var ALL_KEYS = KEYS.concat(['landing_page']);
  var MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

  function read() {
    try {
      var saved = JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
      if (!saved || !saved.ts || Date.now() - saved.ts > MAX_AGE_MS) return null;
      return saved;
    } catch (e) {
      return null;
    }
  }

  function capture() {
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      return;
    }
    var found = {};
    var any = false;
    KEYS.forEach(function (key) {
      var value = params.get(key);
      if (value) {
        found[key] = value.slice(0, 200);
        any = true;
      }
    });
    if (!any) return;
    found.landing_page = window.location.pathname;
    found.ts = Date.now();
    try {
      localStorage.setItem(STORE_KEY, JSON.stringify(found));
    } catch (e) {}
  }

  function cartCookie() {
    var match = document.cookie.match(/(?:^|; )cart=([^;]*)/);
    return match ? match[1] : '';
  }

  function sync() {
    var saved = read();
    var written = false;
    try {
      // Older versions wrote campaign records without the written marker. An
      // expired legacy record still needs its tracking removed from the cart.
      written = localStorage.getItem(WRITTEN_KEY) === '1' || localStorage.getItem(STORE_KEY) !== null;
    } catch (e) {}

    // Nothing stored and nothing of ours on a cart: leave the cart alone.
    if (!saved && !written) return;

    // Always send every tracking key. The cart API merges attributes, so a key left
    // out keeps its old value (for example a gclid from an earlier Google click
    // sitting next to a newer email campaign). Blank values clear them. When the
    // stored set has expired, this clears all of ours. Other cart attributes are
    // never touched.
    var attributes = {};
    ALL_KEYS.forEach(function (key) {
      attributes[key] = saved && saved[key] ? saved[key] : '';
    });

    // One write per cart per campaign set, not one per page view.
    var signature = cartCookie() + '|' + JSON.stringify(attributes);
    try {
      if (sessionStorage.getItem(SYNC_KEY) === signature) return;
    } catch (e) {}

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
      credentials: 'same-origin',
    })
      .then(function (response) {
        if (!response.ok) return;
        try {
          sessionStorage.setItem(SYNC_KEY, cartCookie() + '|' + JSON.stringify(attributes));
          if (saved) {
            localStorage.setItem(WRITTEN_KEY, '1');
          } else {
            localStorage.removeItem(WRITTEN_KEY);
            localStorage.removeItem(STORE_KEY);
          }
        } catch (e) {}
      })
      .catch(function () {});
  }

  if (window.Shopify && window.Shopify.designMode) return;
  capture();
  if (document.readyState === 'complete') {
    sync();
  } else {
    window.addEventListener('load', sync);
  }
})();
